import { useState, useEffect } from "react";

export type ViewportTier = "normal" | "wide" | "ultrawide";

const WIDE_BREAKPOINT = 1800;
const ULTRAWIDE_BREAKPOINT = 2500;

export function useViewportTier(): ViewportTier {
  const [tier, setTier] = useState<ViewportTier>("normal");

  useEffect(() => {
    const mqWide = window.matchMedia(`(min-width: ${WIDE_BREAKPOINT}px)`);
    const mqUltra = window.matchMedia(`(min-width: ${ULTRAWIDE_BREAKPOINT}px)`);

    const update = () => {
      if (mqUltra.matches) setTier("ultrawide");
      else if (mqWide.matches) setTier("wide");
      else setTier("normal");
    };

    update();
    mqWide.addEventListener("change", update);
    mqUltra.addEventListener("change", update);
    return () => {
      mqWide.removeEventListener("change", update);
      mqUltra.removeEventListener("change", update);
    };
  }, []);

  return tier;
}
